export default "__VITE_ASSET__BvheztgG__"